import React from 'react'
import InvoiceReportComponent from '../../Components/Reports/InvoiceReportComponent'

function InvoiceReportPage() {
    return (
        <InvoiceReportComponent/>
    )
}

export default InvoiceReportPage